export default __webpack_public_path__ + "static/media/Warmonger's Shield.d6a16835.jpg";